import { Controller } from "@hotwired/stimulus";
import type { Subscription } from "@rails/actioncable";
import consumer from "../channels/consumer";

export const COUNTDOWN_MS = 5000;

// When this tab's script loaded, in server seconds: read once from the document it first ran in,
// since a Turbo visit swaps the head's meta but keeps the script.
const loadedAt = Number(globalThis.document?.querySelector<HTMLMetaElement>("meta[name=od-rendered-at]")?.content);
let reloading = false;

// Connects to data-controller="live-reload" on the dialog shared/_live_reload draws.
// LiveReloadChannel sends {before}; a tab loaded earlier opens it and reloads.
export default class extends Controller<HTMLDialogElement> {
	subscription?: Subscription;
	timer?: ReturnType<typeof setTimeout>;

	connect() {
		if (this.element.open) this.element.close(); // a page restored from Turbo's cache may have kept it open
		this.subscription = consumer.subscriptions.create("LiveReloadChannel", {
			connected: () => this.subscription?.perform("check"),
			received: ({ before }: { before: number }) => {
				if (!(loadedAt < before) || reloading) return;
				reloading = true;
				this.element.inert = false; // an open sheet panel makes the body's other children inert
				this.element.showModal();
				this.timer = setTimeout(() => this.reload(), COUNTDOWN_MS);
			},
		});
	}

	disconnect() {
		this.subscription?.unsubscribe();
		clearTimeout(this.timer);
		reloading = false;
	}

	reload() {
		location.reload();
	}
}
